module.exports = __webpack_public_path__ + "static/img/p13.faefa428.png";